import constants from '@/api';

const initialState = () => ({
	fileMetaEditorDialog: false,
	mailMeta: {},
	selectedFile: {},
	stockistList: [],
	currentLogs: [],
});
export default {
	namespaced: true,
	state: initialState(),
	mutations: {
		openFileMetaDialog(state) {
			state.fileMetaEditorDialog = true;
		},
		closeFileMetaDialog(state) {
			state.fileMetaEditorDialog = false;
		},
		loadMailMeta(state, mm) {
			state.mailMeta = JSON.parse(JSON.stringify(mm));
		},
		setSelectedFile(state, sf) {
			state.selectedFile = JSON.parse(JSON.stringify(sf));
		},
		setCurrentLogs(state, logs) {
			state.currentLogs = logs;
		},
		setStockistList(state, stkList) {
			state.stockistList = stkList;
		},
		refreshStockistListEmitter() {},
		failure: (s, msg) => {
			console.log('[failure] ', msg);
		},
		resetState(state) {
			const initial = initialState();
			Object.keys(initial).forEach(key => {
				state[key] = initial[key];
			});
		},
	},
	actions: {
		getMailMeta: ({ commit, dispatch }, payload) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'get',
					params: payload,
					url: constants.GET_UNIDENTIFIED_FILES,
				},
				{ root: true }
			)
				.then(data => {
					if (data.ok) {
						commit('loadMailMeta', data.unidentifiedFiles);
						return data;
					} else {
						fail(data.message || 'Failed to load Mail meta');
						return false;
					}
				})
				.catch(err => {
					// console.log('Yo ', err);
					fail(err.toString() || 'Failed to load the Master Data Processes');
				});
		},
		getFileJSON: ({ commit, dispatch }, { renderMode, filePathURL }) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'get',
					params: {},
					url:
						renderMode == 'parsed'
							? constants.UTILITY_PARSED_FILE + filePathURL
							: constants.UTILITY_TRANSFORMED_FILE + filePathURL,
				},
				{ root: true }
			)
				.then(data => {
					return data;
				})
				.catch(err => {
					// console.log('Yo ', err);
					fail(err.toString() || 'Failed to load the Master Data Processes');
				});
		},
		hideFileForMapping: ({ commit, dispatch }, payload) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'post',
					data: payload,
					url: constants.HIDE_FILE_FOR_MAPPING,
				},
				{ root: true }
			)
				.then(data => {
					return data.ok;
				})
				.catch(err => {
					// console.log('Yo ', err);
					fail(err.toString() || 'Failed to load the Master Data Processes');
				});
		},
		verifyMeta: ({ commit, dispatch }, payload) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'post',
					data: payload,
					url: constants.VERIFY_STOCKIST_META,
				},
				{ root: true }
			)
				.then(data => {
					console.log(data);
					if (data.ok) {
						commit('setCurrentLogs', [
							{ mapped: data.returnable.length },
							...data.returnable,
						]);
					} else {
						commit('setCurrentLogs', [
							{
								mapped: data.returnable.length,
								unmapped: data.errors.length,
								total: data.returnable.length + data.errors.length,
							},
							...data.returnable,
							...data.errors,
						]);
					}
					return data.returnable.length > 0;
				})
				.catch(err => {
					// console.log('Yo ', err);
					fail(err.toString() || 'Failed to load the Master Data Processes');
				});
		},
		forceMapStockist: ({ commit, dispatch }, payload) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'post',
					data: payload,
					url: constants.FORCE_STOCKIST_MAPPING,
				},
				{ root: true }
			)
				.then(data => {
					console.log(data);
					return data.ok;
				})
				.catch(err => {
					// console.log('Yo ', err);
					fail(err.toString() || 'Failed to load the Master Data Processes');
				});
		},
		extractAndSaveMeta: ({ commit, dispatch }, payload) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'post',
					data: payload,
					url: constants.APPLY_STOCKIST_MAPPING,
				},
				{ root: true }
			)
				.then(data => {
					console.log(data);
					if (data.ok) {
						commit('setCurrentLogs', data.returnable);
					} else {
						commit('setCurrentLogs', [...data.returnable, ...data.errors]);
					}
					return data.returnable.length > 0;
				})
				.catch(err => {
					// console.log('Yo ', err);
					fail(err.toString() || 'Failed to load the Master Data Processes');
				});
		},
		downloadActualFile: ({ commit, dispatch, state }) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'fileDownload_API_Call',
				{
					method: 'get',
					params: {},
					url:
						constants.UTILITY_OG_FILE +
						'?uuid=' +
						state.selectedFile.originalFilename.split('.')[0],
					responseType: 'blob',
				},
				{ root: true }
			)
				.then(({ data, response }) => {
					if (response.status === 200) {
						commit(
							'openSnackbar',
							{ text: 'Starting Download' },
							{ root: true }
						);
						const url = window.URL.createObjectURL(new Blob([data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', state.selectedFile.originalFilename); //or any other extension
						document.body.appendChild(link);
						link.click();
						return;
					} else {
						commit(
							'openSnackbar',
							{ text: 'Could not start download' },
							{ root: true }
						);
						fail(data.message || 'Failed to start download');
						return;
					}
				})
				.catch(err => {
					// console.log('Yo ', err);
					commit(
						'openSnackbar',
						{ text: 'Could not start download' },
						{ root: true }
					);
					fail(err.toString() || 'Failed to Download Core Data File');
				});
		},
		downloadFile: ({ commit, dispatch, state }) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'fileDownload_API_Call',
				{
					method: 'get',
					params: {},
					url:
						constants.UTILITY_OG_FILE +
						'?uuid=' +
						state.selectedFile.filename.split('.')[0],
					responseType: 'blob',
				},
				{ root: true }
			)
				.then(({ data, response }) => {
					if (response.status === 200) {
						commit(
							'openSnackbar',
							{ text: 'Starting Download' },
							{ root: true }
						);
						const url = window.URL.createObjectURL(new Blob([data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', state.selectedFile.filename); //or any other extension
						document.body.appendChild(link);
						link.click();
						return;
					} else {
						commit(
							'openSnackbar',
							{ text: 'Could not start download' },
							{ root: true }
						);
						fail(data.message || 'Failed to start download');
						return;
					}
				})
				.catch(err => {
					// console.log('Yo ', err);
					commit(
						'openSnackbar',
						{ text: 'Could not start download' },
						{ root: true }
					);
					fail(err.toString() || 'Failed to Download Core Data File');
				});
		},
	},
	getters: {
		fileMetaEditorDialog: state => state.fileMetaEditorDialog,
		mailMeta: state => state.mailMeta,
		selectedFile: state => state.selectedFile,
		stockistList: state => state.stockistList,
		currentLogs: state => state.currentLogs,
	},
};